import { IAActivityIndicator } from './src/ia-activity-indicator.js';

window.customElements.define('ia-activity-indicator', IAActivityIndicator);
